import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import resourcesToBackend from 'i18next-resources-to-backend';
import 'intl-pluralrules';
import { initReactI18next } from 'react-i18next/initReactI18next';

import { i18nConfig } from '@sola/schema/lib/i18n-config.js';
import { endsWithVowel } from '@sola/utils/koreanGrammar.js';

const stripEmptyDigits = (value: number, lang?: string) => {
  const amount =
    Math.floor(value) === value
      ? Intl.NumberFormat(lang, {
          style: 'currency',
          currency: 'USD',
          maximumFractionDigits: 0,
        }).format(value)
      : Intl.NumberFormat(lang, {
          style: 'currency',
          currency: 'USD',
          maximumFractionDigits: 2,
        }).format(value);
  return amount;
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(
    resourcesToBackend(
      (language: string, namespace: string) =>
        import(`./${language}/${namespace}.ts`),
    ),
  )
  .init({
    cleanCode: true,
    debug: false,
    defaultNS: 'common',
    fallbackLng: i18nConfig.defaultLocale,
    fallbackNS: 'common',
    nonExplicitSupportedLngs: true,
    ns: ['priority'],
    partialBundledLanguages: true,
    preload: [i18nConfig.defaultLocale],
    supportedLngs: i18nConfig.locales,
    interpolation: {
      format: (value, format, lang) => {
        switch (format) {
          case 'currency-custom':
            return stripEmptyDigits(value, lang);
          case 'vowel-ending':
            return endsWithVowel(value);
          default:
            return value;
        }
      },
    },
  });
export default i18n;
